export interface ApiStatus{
  accessible: boolean;
  title: string;
  message: string;
}
